import { ListTree } from "lucide-react";
import {
  LamaHierarchyResultsParamsSchema,
  defaultLamaHierarchyResultsParams,
  type LamaHierarchyResultsParams,
  type LamaMaturityHierarchyView,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaHierarchyResultsWidget } from "./Component.js";

/**
 * LAMA Results by Pillar and Category — the Pillar → Category → Question
 * drill-down over the same `lama/maturity-hierarchy@1` payload the overview
 * draws (2026-09-10 ADR-0027 amendment). Params `{}`-strict; the host's
 * `?view=` picks the side, display-only.
 */
export const lamaHierarchyResultsDef: SqlWidgetDef<
  LamaHierarchyResultsParams,
  LamaMaturityHierarchyView
> = {
  kind: "lamaHierarchyResults",
  label: "Results by Pillar and Category",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 520 },
  defaultParams: defaultLamaHierarchyResultsParams,
  Component: LamaHierarchyResultsWidget,
  storage: "sql",
  schema: LamaHierarchyResultsParamsSchema,
  accent: "cyan",
  icon: ListTree,
  subtitle: "Every pillar, category and question",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 960, height: 520 },
  dashboard: {
    icon: ListTree,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
  },
};

registerWidget(lamaHierarchyResultsDef);
